<template>
  <b-modal 
    v-model="localIsVisible" 
    size="lg" 
    hide-footer
    @cancel="onCancel"
  >
    <b-card title="Crear Insumo" class="my-0">
      <validation-observer v-slot="{ invalid }" ref="observer">
        
        <b-form @submit.prevent="submitForm">
          <div class="row">
             <b-form-group class="col-3" label-for="codigo">
            <label>Código: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="codigo"
              rules="required"
            >
              <b-form-input
                id="codigo"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.codigo"
                type="text"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group class="col-9">
            <label>Nombre: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="nombre"
              rules="required"
            >
              <b-form-input
                id="nombre"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.nombre"
                type="text"
                
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

         
          </div>
          <hr>
          <span>Precios:</span>
          <div class="row p-1">
            <b-form-group class="col-2" label-for="precio1">
            <label>Iess: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precio1"
              rules="required"
            >
              <b-form-input
                id="precio1"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.precioJson.iess_n1"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || charCode === 44"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
         
            <b-form-group class="col-2" label-for="precio2">
            <label>Issfa N1: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precio2"
              rules="required"
            >
              <b-form-input
                id="precio2"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.precioJson.issfa_n1"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || charCode === 44"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
            <b-form-group class="col-2" label-for="precio3">
            <label>Issfa N2: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precio3"
              rules="required"
            >
              <b-form-input
                id="precio3"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.precioJson.issfa_n2"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || charCode === 44"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
            <b-form-group class="col-2" label-for="precio4">
            <label>Isspol: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precio4"
              rules="required"
            >
              <b-form-input
                id="precio4"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.precioJson.isspol_n1"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || charCode === 44"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group class="col-2" label-for="precio5">
            <label>Particular: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precio5"
              rules="required"
            >
              <b-form-input
                id="precio5"
                :state="errors.length > 0 ? false : null"
                v-model="insumo.precioJson.particular"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || charCode === 44"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          </div>

          <hr>
        <span>Activo/Inactivo</span>
        <div class="row p-1">
          <b-form-group class="col" label="Iess:" label-for="estado-1">
          <b-form-checkbox
            id="estado-1"
            v-model="insumo.estadoJson.iess"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Issfa:" label-for="estado-2">
          <b-form-checkbox
            id="estado-2"
            v-model="insumo.estadoJson.issfa"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Isspol:" label-for="estado-3">
          <b-form-checkbox
            id="estado-3"
            v-model="insumo.estadoJson.isspol"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Particular:" label-for="estado-4">
          <b-form-checkbox
            id="estado-4"
            v-model="insumo.estadoJson.particular"
            switch
          />
        </b-form-group>
        </div>

         
          
          <b-form-group label-for="nummax">
            <label>Num Max: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="nummax"
              rules="required"
            >
              <b-form-input
                id="numMax"
                v-model="insumo.numMax"
                type="number"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                required
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        
          <b-button 
            type="submit" 
            variant="primary"
            class="mt-2"
          >
            Crear Insumo
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { establecimientosService } from "@/views/administracion/services";
import { required } from '@validations'


export default {

  name: "CrearInsumo",

  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localIsVisible:false,
      idEstablecimiento:null,

      required,

      establecimientosOpts : [],
      insumo: {
        id: "",
        nombre: "",
        codigo: "",
        precioNeto: 0,
        precioTecho: 0,
        numMax: 1,
        presentacion: "",
        establecimiento: "",
        estado: "1",
        precioJson:{
          iess_n1:0,
          issfa_n1:0,
          issfa_n2:0,
          particular:0,
          isspol_n1:0
        },
        estadoJson:{
          iess:false,
          isspol:false,
          issfa:false,
          particular:false
        }
      },
    };
  },

  created() {
    this.loadEstablecimientos();
    const user = JSON.parse(localStorage.getItem('detalleusuario'))
    this.idEstablecimiento = user.establecimiento ? user.establecimiento.id : ""
  },


  methods: {
    formatPrecioNeto() {
      if (this.insumo.precioNeto) {
        this.insumo.precioNeto = parseFloat(this.insumo.precioNeto).toFixed(4);
      }
    },


    onCancel() {
      this.localIsVisible = false
    },

    async loadEstablecimientos(){
      const responseEstablecimientos = await establecimientosService.getForSelect();
      this.establecimientosOpts = responseEstablecimientos.map( item => (
        { value: item.id, text: item.Descripcion }
      ));
    },

    async submitForm() {

      this.formatPrecioNeto(); 

      const precioNetoFormateado = this.insumo.precioNeto
      
      const precioTechoFormateado = parseFloat(
        this.insumo.precioTecho
      ).toFixed(4);

      const query = `
        mutation crearInsumo($insumo: InsumoInput!) {
          crearInsumo(insumo: $insumo) {
            insumoCreado {
              token
              id
              precioNeto
              precioTecho
            }
            status
            message
          }
        }   
      `;

      const variables = {
        insumo: {
          codigo: this.insumo.codigo,
          nombre: this.insumo.nombre,
          presentacion: '',
          numMax: parseInt(this.insumo.numMax),
          // precioNeto: precioNetoFormateado,
          // precioTecho: precioNetoFormateado,
          precioJson: JSON.stringify(this.insumo.precioJson),
          estadoJson: JSON.stringify(this.insumo.estadoJson),
          estado: this.insumo.estado,
          establecimiento: this.idEstablecimiento,
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.crearInsumo.status === "success") {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El insumo se creó correctamente.",
          });

          this.$router.go(0);

        } else {
          this.$swal({
            title: "Error",
            text: response.data.data.crearAdmision.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear el insumo.",
        });
      }
    },
  },

  watch: {
    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }
  }
};
</script>
